import firebase from "firebase/app";
export default {

  getToken() {
    const applicationServerPublicKey =
      "BJWI2MoUrK8LswOD2F2sxMqF2KHf-E8EwIzRwL8-zO48eIPCpeV4GpcyZ0MgyEnmXnBa0d3z2z-i5xOLKQCoDIU";
    const messaging = firebase.messaging(firebase.app());
    return messaging.getToken(messaging, {
      vapidKey: applicationServerPublicKey,
    });
  },
  urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  },
  notifyEmail(cartons, template_name, template_data) {
    // if locations is localhost, not send notification
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1") return;
    let trabajos = this.trabajos(cartons),
      notificaciones = this.notificaciones_trabajos(
        trabajos, template_name
      );
    console.log(notificaciones);
    notificaciones.forEach((notify) => {
      Object.assign(notify.template_data, template_data);
      this.notifyEvent(notify);
    });
  },
  notificaciones_trabajos(trabajos, template_name) {
    let notificaciones = [],
      ccmasterids = Object.keys(trabajos);
    ccmasterids.forEach((ccmasterid) => {
      let notify = {
        ccmasterid: ccmasterid,
        template_name: template_name,


        template_data: {
          ccmasterid: ccmasterid,
          dsforderid: trabajos[ccmasterid]["dsforderid"],
          cartons_list: trabajos[ccmasterid].cartons.map(c => '#' + c.no_carton).join(', '),
          trabajo: trabajos[ccmasterid],

          //accion_url: `https://emprende.soltarimpresores.com/track?no_orden=${ccmasterid}`,

        },
      };
      notificaciones.push(notify);
    });
    return notificaciones;
  },
  trabajos(cartons) {
    let cartons_values = Object.values(cartons),
      trabajos = {};
    cartons_values.sort((a, b) => {
      return a.no_carton.localeCompare(b.no_carton);
    });

    cartons_values.forEach((carton) => {
      let trabajo = trabajos[carton.ccmasterid];
      if (trabajo) {
        trabajo.cartons.push(carton);
        trabajo.jobparts[carton.jobpart].cartons.push(carton);
      } else {
        let jobparts = {};
        jobparts[carton.jobpart] = { cartons: [carton] };
        trabajos[carton.ccmasterid] = {
          dsforderid: carton.dsforderid,
          cartons: [carton],
          jobparts: jobparts,
        };
        console.log("trabajos", carton.ccmasterid, trabajos[carton.ccmasterid]);
      }
    });
    return trabajos;
  },
  notifyEvent(notify) {
    notify.debug = location.hostname === "localhost"
    let req = new Request("https://emprende.soltarimpresores.com/api/notify", {
      method: "post",
      //mode: "no-cors",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify(notify),
    });
    fetch(req).then((res) => {
      if (res.ok)
        res.json().then((status) => {
          console.log(status);
        });
      else
        res.json().then((response) => {
          console.warn(`Un error ha ocurrido: ${response.message}`);
        });
    });
  },
  checkClaims: (user) => {
    let path = window.location.pathname.slice(1);
    user
      .getIdTokenResult()
      .then((idTokenResult) => {
        // Confirm the user is an Admin.
        let claims = idTokenResult.claims;
        if (path.length && (!claims.permisos || !claims.permisos[path])) {
          window.location.href = "/403";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  relacionarAlmacenesShipvias(almacenes, shipvias) {
    let merge = {};
    almacenes = almacenes.sort((a, b) => {
      return a.iclocdesc.localeCompare(b.iclocdesc);
    });
    almacenes.forEach((almacen) => {
      let almacenDesc = almacen.iclocdesc;

      let ship = shipvias.find((shipvia) => {
        return (
          shipvia.sydescription.indexOf(almacenDesc) > -1 ||
          almacenDesc.indexOf(shipvia.sydescription) > -1
        );
      });
      if (!ship) ship = {};
      ship = { almacen: almacen, shipvia: ship };
      merge[almacen.iclocdesc + "\t" + almacen.iclocid] = ship;
    });
    return merge;
  },
  compareStrings(x, y) {
    console.log("comparar", x, y);
    let tokens = x.split(/\W/),
      match = 0,
      target = y.toLowerCase();
    tokens.forEach((t) => {
      t = t.toLowerCase();
      match += target.includes(t);
    });
    return match / tokens.length;
  },
  getMultiplePayments(ccmasterids){
    let req = new Request("https://emprende.soltarimpresores.com/api/payments-multi", {
      method: "post",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify({orders: ccmasterids}),
    });
    return fetch(req)
  },
  createCartonEvent(status, desc, user_email){
    return {
      status: status,
      desc: desc,
      user_email: user_email,
      created:"SERVER_TIMESTAMP",
      created_at: new Date(),
    };
  }
};
